(function () {
  'use strict';

  /* ─────────────────────────────────────────────────
     GALLERY
  ───────────────────────────────────────────────── */
  function initGallery() {
    var gallery = document.getElementById('ProductGallery');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.undg-gallery__slide');
    var thumbs  = gallery.querySelectorAll('.undg-gallery__thumb');
    function goTo(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
  }

  /* ─────────────────────────────────────────────────
     VARIANT SELECTOR
     Uses an ordered array (not object) for option
     values — guarantees correct key regardless of
     JS engine or number of options.
  ───────────────────────────────────────────────── */
  function initVariantSelector() {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var product = window.__undgProduct;
    if (!product) return;

    var hiddenInput = form.querySelector('input[name="id"]');
    var addBtn      = document.getElementById('UndgAddBtn');
    var priceEl     = document.querySelector('.undg-product__price');

    // Build variant lookup map
    var variantMap = {};
    product.variants.forEach(function (v) {
      var parts = [];
      if (v.option1 != null) parts.push(v.option1);
      if (v.option2 != null) parts.push(v.option2);
      if (v.option3 != null) parts.push(v.option3);
      variantMap[parts.join('|')] = v;
    });

    // Ordered array — index = option position
    var totalOptions = product.options.length;
    var selected     = new Array(totalOptions).fill(null);

    // Pre-fill from currently selected variant
    var init = product.variants.find(function (v) {
      return v.id === product.selected_or_first_available_variant_id;
    }) || product.variants[0];

    if (init) {
      if (init.option1 != null) selected[0] = init.option1;
      if (init.option2 != null) selected[1] = init.option2;
      if (init.option3 != null) selected[2] = init.option3;
    }

    function key() {
      return selected.filter(function (v) { return v !== null; }).join('|');
    }

    function applyVariant(v) {
      if (!v) return;
      // Update hidden input so form submits correct variant
      if (hiddenInput) hiddenInput.value = v.id;

      // Update displayed price
      if (priceEl) {
        priceEl.textContent = new Intl.NumberFormat('es-CO', {
          style: 'currency', currency: 'COP',
          minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(v.price / 100);
      }

      // Update button state
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'AGREGAR AL CARRITO';
          addBtn.classList.remove('is-soldout');
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'AGOTADO';
          addBtn.classList.add('is-soldout');
        }
      }

      // Sync URL without reload
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    // Attach handlers to all option buttons
    form.querySelectorAll('.undg-option__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx   = parseInt(this.dataset.optionIndex, 10);
        var value = this.dataset.value;
        // Deselect siblings
        form.querySelectorAll(
          '.undg-option__btn[data-option-index="' + idx + '"]'
        ).forEach(function (b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        selected[idx] = value;
        applyVariant(variantMap[key()]);
      });
    });

    // Apply on load
    applyVariant(init);
  }

  /* ─────────────────────────────────────────────────
     ADD TO CART
     Strategy: use Shopify's native form submission
     via fetch so the theme's own cart drawer/
     notification opens correctly — no manual drawer
     manipulation that causes the grey-overlay freeze.
  ───────────────────────────────────────────────── */
  function initAddToCart() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // Block default browser navigation
      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = document.getElementById('UndgAddBtn');
      if (!btn || btn.disabled) return;

      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;

      if (!variantId || isNaN(variantId)) {
        setBtn(btn, 'SELECCIONA UNA TALLA', '#1a1a1a', '#e03030', false);
        setTimeout(function () {
          setBtn(btn, 'AGREGAR AL CARRITO', '', '', false);
        }, 2500);
        return;
      }

      var original = btn.textContent;
      setBtn(btn, 'AGREGANDO...', '', '', true);

      // POST to /cart/add.js
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type':     'application/json',
          'Accept':           'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'No se pudo agregar');
          });
        }
        return res.json();
      })
      .then(function () {
        setBtn(btn, '✓ AGREGADO', '#e03030', '#fff', false);

        // Let the theme handle its own cart UI
        // by dispatching the standard Shopify section-render event
        notifyTheme();

        setTimeout(function () {
          setBtn(btn, original, '', '', false);
        }, 2500);
      })
      .catch(function (err) {
        console.error('[UNDG] cart error:', err.message);
        setBtn(btn, err.message || 'ERROR — INTENTA DE NUEVO', '#1a1a1a', '#e03030', false);
        setTimeout(function () {
          setBtn(btn, original, '', '', false);
        }, 3500);
      });
    });
  }

  function setBtn(btn, text, bg, color, disabled) {
    btn.textContent      = text;
    btn.style.background = bg;
    btn.style.color      = color;
    btn.disabled         = disabled;
  }

  /* ─────────────────────────────────────────────────
     NOTIFY THEME CART
     Only uses safe, read-only DOM operations:
     - Updates the visible cart count
     - Fires the *specific* event the live theme uses
       (identified from the page source: ss-glow /
        Dawn-family with cart-notification element)
     Does NOT add/remove classes on overlays or
     drawers — that caused the grey-freeze.
  ───────────────────────────────────────────────── */
  function notifyTheme() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {

      // ── 1. Re-render #cart-icon-bubble via the header section ──────────
      // cart-icon-bubble is an element ID *inside* the header section,
      // not a standalone section — so we must request /?sections=header.
      fetch('/?sections=header', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var sectionHtml = sections['header'];
        if (!sectionHtml) return;
        var doc       = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var newBubble = doc.getElementById('cart-icon-bubble');
        var curBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && curBubble) {
          // Replace the entire anchor so the SVG icon also switches
          // between icon-cart-empty and icon-cart correctly.
          curBubble.innerHTML = newBubble.innerHTML;
        }
      })
      .catch(function () {
        // Sections API unavailable — fall back to manual badge update
        updateCount(cart.item_count);
      });

      // ── 2. Trigger cart-notification (Dawn native) ──────────────────────
      // cart-notification.js listens for a custom 'cart-notification:open'
      // event dispatched on document with the cart payload as detail.
      document.dispatchEvent(new CustomEvent('cart-notification:open', {
        bubbles: true,
        detail:  { cart: cart }
      }));

      // ── 3. Broad fallback events for other theme scripts ────────────────
      ['cart:updated', 'cart:refresh', 'CartUpdate'].forEach(function (name) {
        try {
          document.dispatchEvent(new CustomEvent(name, {
            bubbles: true,
            detail:  { cart: cart }
          }));
        } catch (e) {}
      });
    })
    .catch(function (err) {
      console.error('[UNDG] cart notify error:', err.message);
    });
  }

  function updateCount(n) {
    // Only target explicit count elements.
    // IMPORTANT: Do NOT use [aria-hidden] here — that selector also matches
    // the cart SVG icon (which has aria-hidden="true") and would destroy it
    // by replacing its entire content with just the count number.
    // Badge injection is intentionally omitted: the Sections API re-render
    // in notifyTheme() handles it with the exact markup the theme uses.
    var selectors = [
      '.cart-count-bubble span:not(.visually-hidden)',
      '[data-cart-count]',
      '[data-cart-item-count]',
      '.cart-count',
      '.cart__count',
      '#CartCount',
      '#cart-count',
      '.js-cart-count',
      '[data-header-cart-count]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = n;
        el.classList.remove('hidden', 'is-empty');
        el.removeAttribute('hidden');
      });
    });
  }

  /* ─────────────────────────────────────────────────
     ACCORDIONS
  ───────────────────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('.undg-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var acc      = this.closest('.undg-accordion');
        var body     = acc.querySelector('.undg-accordion__body');
        var icon     = acc.querySelector('.undg-accordion__icon');
        var expanded = this.getAttribute('aria-expanded') === 'true';

        // Close all
        document.querySelectorAll('.undg-accordion').forEach(function (a) {
          a.querySelector('.undg-accordion__trigger').setAttribute('aria-expanded', 'false');
          a.querySelector('.undg-accordion__body').style.display = 'none';
          a.querySelector('.undg-accordion__icon').textContent   = '+';
        });

        // Open clicked if it was closed
        if (!expanded) {
          this.setAttribute('aria-expanded', 'true');
          body.style.display = 'block';
          icon.textContent   = '×';
        }
      });
    });
  }

  /* ─────────────────────────────────────────────────
     SIZE GUIDE SMOOTH SCROLL
  ───────────────────────────────────────────────── */
  function initSizeGuideLink() {
    document.querySelectorAll('a[href="#undg-size-guide"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById('undg-size-guide');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ─────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariantSelector();
    initAccordions();
    initAddToCart();
    initSizeGuideLink();
  });

})();